import { useUser } from "@clerk/nextjs";
/*
export function ShowIfRole({ role="accepted_member", fallback = null, children }) {
    const { user } = useUser();

    if (user?.publicMetadata?.role !== role) {
        return fallback;
    }

    return children;
}
    */


const ROLES = [
  "visitor",
  "new_applicant",
  "denied_applicant",
  "newcomer",
  "offered_member",
  "accepted_member",
];

export function ShowIfRole({ role = "accepted_member", fallback = null, children }) {
  const { user } = useUser();

  const requiredIndex = ROLES.indexOf(role);
  const userIndex = ROLES.indexOf(user?.publicMetadata?.role as any);

  if (userIndex < requiredIndex) {
    return fallback;
  }

  return children;
}